import { render, staticRenderFns } from "./CheckComponent.vue?vue&type=template&id=4018c7f2&"
import script from "./CheckComponent.vue?vue&type=script&lang=js&"
export * from "./CheckComponent.vue?vue&type=script&lang=js&"
import style0 from "./CheckComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4018c7f2')) {
      api.createRecord('4018c7f2', component.options)
    } else {
      api.reload('4018c7f2', component.options)
    }
    module.hot.accept("./CheckComponent.vue?vue&type=template&id=4018c7f2&", function () {
      api.rerender('4018c7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/CheckComponent.vue"
export default component.exports